import { render, staticRenderFns } from "./DealersCPFFormList.vue?vue&type=template&id=6ef3dcca&"
import script from "./DealersCPFFormList.vue?vue&type=script&lang=ts&"
export * from "./DealersCPFFormList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports